export const FILE_UPLOAD_DESCRIPTION =
  "Securely request and collect any required file from contractors for your own manual review. This is ideal for documents like portfolio samples or training certificates that don't need automated validation.";

export const FILE_UPLOAD_EXAMPLE_USE_CASES =
  "Certifications, portfolio samples, training certificates.";

export const FILE_UPLOAD_COST = "Free (included)";

export const FILE_UPLOAD = {
  description: FILE_UPLOAD_DESCRIPTION,
  exampleUseCases: FILE_UPLOAD_EXAMPLE_USE_CASES,
  cost: FILE_UPLOAD_COST
};
